<template>
  <header>
    <div class="container">
      <div class="top">
        <a class="brand" href="/"
          ><img
            src="@/assets/img/logo-cap-covid.png"
            alt="CAP-COVID logo"
          />CAP-COVID</a
        >
        <a
          class="btn btn-outline menu"
          href="#menu"
          v-bind:class="[isMenuActive ? 'active' : '']"
          v-on:click="menu($event)"
          >Menu</a
        >
      </div>
      <nav id="nav" v-bind:class="[isMenuActive ? 'active' : '']">
        <ul>
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/our-team">Our team</router-link></li>
          <li>
            <router-link to="/participant-information"
              >Participant information</router-link
            >
          </li>
          <li>
            <router-link to="/useful-links">Useful links</router-link>
          </li>
          <li>
            <router-link to="/privacy-policy">Privacy policy</router-link>
          </li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  data: function() {
    return {
      isMenuActive: false
    };
  },
  methods: {
    menu: function() {
      this.isMenuActive = !this.isMenuActive;
    }
  }
};
</script>
